import { atarrayaApi } from '../../api-common'

export const state = {
  animalsType: [],
  animals: [],
  generations: [],
  simpleGenerations: [],
  populations: [],
  curves: [],
  mortality: []
}

export const getters = {
  animalsType: (state) => state.animalsType,
  animals: (state) => state.animals,
  generations: (state) => state.generations,
  simpleGenerations: (state) => state.simpleGenerations,
  populations: (state) => state.populations,
  curves: (state) => state.curves,
  mortality: (state) => state.mortality
}

export const mutations = {
  LOAD_ANIMALS_TYPE(state, data) {
    state.animalsType = data
  },

  ADD_ANIMAL_TYPE(state, data) {
    state.animalsType.push(data)
  },

  UPDATE_ANIMAL_TYPE(state, data) {
    const index = state.animalsType.findIndex((u) => u.id === data.id)
    if (index >= 0) {
      for (const attr in data) {
        if (Object.hasOwnProperty.call(state.animalsType[index], attr)) {
          state.animalsType[index][attr] = data[attr]
        }
      }
    }
  },

  DELETE_ANIMAL_TYPE(state, item) {
    state.animalsType.splice(state.animalsType.indexOf(item), 1)
  },

  LOAD_ANIMALS(state, data) {
    state.animals = data
  },

  ADD_ANIMAL(state, data) {
    state.animals.push(data)
  },

  UPDATE_ANIMAL(state, data) {
    const index = state.animals.findIndex((u) => u.id === data.id)
    if (index >= 0) {
      for (const attr in data) {
        if (Object.hasOwnProperty.call(state.animals[index], attr)) {
          state.animals[index][attr] = data[attr]
        }
      }
    }
  },

  DELETE_ANIMAL(state, item) {
    state.animals.splice(state.animals.indexOf(item), 1)
  },

  LOAD_GENERATIONS(state, data) {
    state.generations = data
  },

  LOAD_SIMPLE_GENERATIONS(state, data) {
    state.simpleGenerations = data
  },

  ADD_GENERATION(state, data) {
    state.generations.push(data)
  },

  UPDATE_GENERATION(state, data) {
    const index = state.generations.findIndex((u) => u.id === data.id)
    if (index >= 0) {
      for (const attr in data) {
        if (Object.hasOwnProperty.call(state.generations[index], attr)) {
          state.generations[index][attr] = data[attr]
        }
      }
    }
  },

  DELETE_GENERATION(state, item) {
    state.generations.splice(state.generations.indexOf(item), 1)
  },

  LOAD_POPULATIONS(state, data) {
    state.populations = data
  },

  ADD_POPULATION(state, data) {
    state.populations.unshift(data)
  },

  UPDATE_POPULATION (state, data) {
    const index = state.populations.findIndex(p => p.id === data.id)
    // if (index >= 0) {
    //   for (const attr in data) {
    //     if (Object.hasOwnProperty.call(state.populations[index], attr)) {
    //       state.populations[index][attr] = data[attr]
    //     }
    //   }
    // }
    if (index !== -1) {
      // Actualizar manteniendo la reactividad
      state.populations.splice(index, 1, data)
    } else {
      // Si no existe, añadir
      state.populations.unshift(data)
    }
  },

  DELETE_POPULATION(state, item) {
    state.populations.splice(state.populations.indexOf(item), 1)
  },

  LOAD_CURVES(state, data) {
    state.curves = data
  },

  ADD_CURVE(state, data) {
    state.curves.push(data)
  },

  DELETE_CURVE(state, item) {
    state.curves.splice(state.curves.indexOf(item), 1)
  },

  ADD_MORTALITY(state, data) {
    state.mortality.push(data)
  }
}

export const actions = {
  async getAnimalsType({ commit }) {
    const response = await atarrayaApi.get('/taxonomy/animal-types')
    commit('LOAD_ANIMALS_TYPE', response.data.data)
    return response.data.data
  },

  async addAnimalsType({ commit }, data) {
    const response = await atarrayaApi.post('/taxonomy/animal-types', data)
    commit('ADD_ANIMAL_TYPE', response.data.data)
  },

  async editAnimalsType({ commit }, data) {
    await atarrayaApi.patch(`/taxonomy/animal-types/${data.id}`, data)
    commit('UPDATE_ANIMAL_TYPE', data)
  },

  async deleteAnimalsType({ commit }, item) {
    await atarrayaApi.delete(`/taxonomy/animal-types/${item.id}`)
    commit('DELETE_ANIMAL_TYPE', item)
  },

  async getAnimals({ commit }) {
    const response = await atarrayaApi.get('/taxonomy/animals')
    commit('LOAD_ANIMALS', response.data.data)
    return response.data.data
  },

  async addAnimal({ commit }, data) {
    const response = await atarrayaApi.post('/taxonomy/animals', data)
    commit('ADD_ANIMAL', response.data.data)
  },

  async editAnimal({ commit }, data) {
    await atarrayaApi.patch(`/taxonomy/animals/${data.id}`, data)
    commit('UPDATE_ANIMAL', data)
  },

  async deleteAnimals({ commit }, item) {
    await atarrayaApi.delete(`/taxonomy/animals/${item.id}`)
    commit('DELETE_ANIMAL', item)
  },

  async getGenerations({ commit }) {
    const response = await atarrayaApi.get('/taxonomy/generations')
    commit('LOAD_GENERATIONS', response.data.data)
    return response.data.data
  },

  async getSimpleGenerations({ commit }) {
    const response = await atarrayaApi.get('/taxonomy/generations')
    commit('LOAD_SIMPLE_GENERATIONS', response.data.data)
    return response.data.data
  },

  async getSimpleGenerationsByFilters({ commit }, data) {
    const response = await atarrayaApi.get('/taxonomy/generations', {
      params: {
        farmId: data.farmId
      }
    })
    commit('LOAD_SIMPLE_GENERATIONS', response.data.data)
    return response.data.data
  },

  async addGeneration({ commit }, data) {
    const response = await atarrayaApi.post('/taxonomy/generations', data)
    commit('ADD_GENERATION', response.data.data)
  },

  async editGeneration({ commit }, data) {
    await atarrayaApi.patch(`/taxonomy/generations/${data.id}`, data)
    commit('UPDATE_GENERATION', data)
  },

  async deleteGeneration({ commit }, item) {
    await atarrayaApi.delete(`/taxonomy/generations/${item.id}`)
    commit('DELETE_GENERATION', item)
  },

  async getPopulations({ commit }) {
    const response = await atarrayaApi.get('/taxonomy/populations')
    commit('LOAD_POPULATIONS', response.data.data)
    return response.data.data
  },

  async getPopulationsById({ commit }, item) {
    const response = await atarrayaApi.get('/taxonomy/populations', {
      params: {
        id: item
      }
    })
    commit('LOAD_POPULATIONS', response.data.data)
    return response.data.data
  },

  async getPopulationsByFilters({ commit }, data) {
    const response = await atarrayaApi.get('/taxonomy/populations', {
      params: {
        id: data.populationId,
        genId: data.generations,
        cntId: data.containers,
        status: data.status,
        startedYear: data.startedYear,
        finishedYear: data.finishedYear
      }
    })
    commit('LOAD_POPULATIONS', response.data.data)
    return response.data.data
  },

  async addPopulation({ commit }, data) {
    const response = await atarrayaApi.post('/taxonomy/populations', data)
    commit('ADD_POPULATION', response.data.data)
    return response
  },

  async editPopulation({ commit }, data) {
    await atarrayaApi.patch(`/taxonomy/populations/${data.id}`, data)
    commit('UPDATE_POPULATION', data)
  },

  async deletePopulation({ commit }, item) {
    await atarrayaApi.delete(`/taxonomy/populations/${item.id}`)
    commit('DELETE_POPULATION', item)
  },

  async getCurves({ commit }, data) {
    const response = await atarrayaApi.get(`/taxonomy/growth-curves?animalId=${data}`)
    commit('LOAD_CURVES', response.data.data)
    return response.data.data
  },

  async addCurve({ commit }, data) {
    const response = await atarrayaApi.post('/taxonomy/growth-curves', data)
    commit('ADD_CURVE', response.data.data)
  },

  async deleteCurve({ commit }, item) {
    await atarrayaApi.delete(`/taxonomy/growth-curves/${item.id}`)
    commit('DELETE_CURVE', item)
  },

  async addMortality({ commit }, data) {
    const response = await atarrayaApi.post(
      `/taxonomy/animals/${data.id}/mortality`,
      data.mortality
    )
    commit('ADD_MORTALITY', response.data.data)
  },

  async getAnimalsWithMortality({ commit }) {
    const response = await atarrayaApi.get('/taxonomy/animals?with=mortality')
    commit('LOAD_ANIMALS', response.data.data)
    return response.data.data
  }
}
